import React, { FC, useEffect, useState } from 'react';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import MenuIcon from '@mui/icons-material/Menu';
import { getUser } from 'localStorage/authStorage';
import { ProfileResponse } from 'models/auth/interfaces/auth.interface';
import { logout } from 'store/actions/user';
import {
	getMobileFlatNavItems,
	NavItem,
} from 'components/layouts/main/navigation/navConfig';
import {
	clearDevicesFilter,
	clearExternalInventoryFilter,
	clearInventoryFilter,
	clearNotificationsFilter,
	clearOzocioFilter,
	clearOzonioFilter,
	clearOzonerFilter,
	clearRepossessionsFilter,
	clearWriteOffFilter,
} from 'localStorage/filterStorage';

import './mobileNav.scss';

function getInitials(name?: string): string {
	if (!name) return '?';
	const parts = name.trim().split(/\s+/);
	if (parts.length >= 2) {
		return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
	}
	return name.slice(0, 2).toUpperCase();
}

const clearFilters = () => {
	clearInventoryFilter();
	clearExternalInventoryFilter();
	clearOzonerFilter();
	clearOzocioFilter();
	clearOzonioFilter();
	clearRepossessionsFilter();
	clearNotificationsFilter();
	clearDevicesFilter();
	clearWriteOffFilter();
};

const MobileNavLink: FC<{ item: NavItem }> = ({ item }) => {
	const { to, name, img: Icon } = item;
	const resolved = useResolvedPath(to);
	const match = useMatch({ path: `${resolved.pathname}/*`, end: true });

	return (
		<Link
			to={to}
			className={`mobile_nav_item ${match ? 'active' : ''}`}
			onClick={clearFilters}
		>
			<Icon className="mobile_nav_icon" aria-hidden="true" />
			<span>{name}</span>
		</Link>
	);
};

function MobileNav() {
	const dispatch = useDispatch();
	const [user, setUser] = useState<ProfileResponse | null>(null);
	const [menuOpen, setMenuOpen] = useState(false);

	useEffect(() => {
		setUser(getUser());
	}, []);

	const navItems = getMobileFlatNavItems(user);

	if (navItems.length <= 1) {
		return null;
	}

	const handleLogout = () => {
		setMenuOpen(false);
		dispatch(logout());
	};

	return (
		<>
			<nav className="mobile_nav" aria-label="Navegación principal">
				<div className="mobile_nav_items">
					{navItems.map((item) => (
						<MobileNavLink key={item.to} item={item} />
					))}
					<button
						type="button"
						className={`mobile_nav_item ${menuOpen ? 'active' : ''}`}
						onClick={() => setMenuOpen(true)}
						aria-label="Menú de usuario"
					>
						<MenuIcon className="mobile_nav_icon" sx={{ fontSize: 20 }} />
						<span>Menú</span>
					</button>
				</div>
			</nav>

			{menuOpen && (
				<>
					<div
						className="mobile_nav_menu_overlay"
						onClick={() => setMenuOpen(false)}
						onKeyPress={() => setMenuOpen(false)}
						role="button"
						tabIndex={0}
						aria-label="Cerrar menú"
					/>
					<div className="mobile_nav_menu_panel">
						<div className="mobile_nav_menu_header">
							<div className="mobile_nav_menu_avatar">
								{getInitials(user?.name)}
							</div>
							<div>
								<div className="mobile_nav_menu_name">
									{user?.name || 'Usuario'}
								</div>
								<div className="mobile_nav_menu_role">
									{user?.role?.join(', ') || ''}
								</div>
							</div>
						</div>
						<button
							type="button"
							className="mobile_nav_logout"
							onClick={handleLogout}
						>
							Cerrar sesión
						</button>
					</div>
				</>
			)}
		</>
	);
}

export default MobileNav;
